import React, { useEffect, useRef, useState } from 'react';
import ReactCrop, { centerCrop, makeAspectCrop } from 'react-image-crop';
import { useDebounceEffect } from './utils/useDebounceEffect';
import { Grid } from '@material-ui/core';
import { SdmTypography } from 'components/SdmTypography';
import { multiCanvasPreview } from './utils/multiCanvasPreview';

const CustomMultiFileCropper = ({
  img,
  style,
  previewTitle,
  onFileCropped,
  maxHeight = 900,
  minHeight = 900,
  minWidth = 300,
  maxWidth = 1200,
}) => {
  // States
  const [imgSrc, setImgSrc] = useState('');
  const [imgSize, setImgSize] = useState({ width: 0, height: 0 });
  // const [scaleFactor, setScaleFactor] = useState(0.4);
  const [scaleFactor] = useState(0.2);
  const [fileInfo, setFileInfo] = useState({
    name: '',
    type: '',
  });
  const [crop, setCrop] = useState();
  const [completedCrop, setCompletedCrop] = useState();
  // Refs
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);

  // const averageWidth = (maxWidth + minWidth) / 2;
  // const averageHeight = (maxHeight + minHeight) / 2;

  // Effects
  useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        await multiCanvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop,
          1,
          0
          // completedCrop?.width,
          // completedCrop?.height
        );
        const canvas = previewCanvasRef.current;
        canvas.toBlob((blob) => {
          const file = new File([blob], fileInfo.name, {
            type: fileInfo.type,
          });
          onFileCropped(file);
        }, fileInfo.type);
      }
    },
    100,
    [completedCrop]
  );

  useEffect(() => {
    if (img) onSelectFiles(img);
  }, [img]);

  // Functions
  const centerAspectCrop = (mediaWidth, mediaHeight, aspect) => {
    const input = makeAspectCrop(
      {
        unit: 'px',
        width: maxWidth * scaleFactor,
        height: maxHeight * scaleFactor,
      },
      aspect
    );
    return centerCrop(input, mediaWidth, mediaHeight);
  };

  const onSelectFiles = (file) => {
    if (file) {
      setFileInfo({ name: file?.name, type: file?.type });
      setCrop(undefined); // Makes crop preview update between images.
      const reader = new FileReader();
      reader.addEventListener('load', (e) => {
        setImgSrc(reader.result?.toString() || '');
        // Width Logic
        //Initiate the JavaScript Image object.
        const image = new Image();
        //Set the Base64 string return from FileReader as source.
        image.src = e.target.result;
        //Validate the File Height and Width.
        image.onload = function () {
          const width = this.width;
          const height = this.height;
          setImgSize({ width, height });
        };
      });
      reader.readAsDataURL(file);
    }
  };

  const onImageLoad = (e) => {
    if (maxWidth && maxHeight) {
      const { width, height } = e.currentTarget;
      setCrop(centerAspectCrop(width, height, maxWidth / maxHeight));
    }
  };

  return (
    <div style={style}>
      <Grid container>
        <Grid item xs={6}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
            }}
          >
            {!!imgSrc && imgSize.width && (
              <ReactCrop
                crop={crop}
                onChange={(_, percentCrop) => setCrop(percentCrop)}
                onComplete={(c) => {
                  const _copyCompletedCrop = {
                    ...c,
                  };
                  setCompletedCrop((prev) => ({
                    ...prev,
                    ..._copyCompletedCrop,
                  }));
                }}
                style={{ maxWidth: imgSize.width * scaleFactor }}
                maxHeight={maxHeight * scaleFactor}
                minHeight={minHeight * scaleFactor}
                minWidth={minWidth * scaleFactor}
                maxWidth={maxWidth * scaleFactor}
              >
                <img
                  ref={imgRef}
                  alt="Crop me"
                  src={imgSrc}
                  style={{
                    transform: `scale(1) rotate(0deg)`,
                    maxWidth: `100%`,
                  }}
                  onLoad={onImageLoad}
                />
              </ReactCrop>
            )}
          </div>
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={4}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
            }}
          >
            {!!completedCrop && (
              <SdmTypography variant={'h3'}>{previewTitle}</SdmTypography>
            )}
            {!!completedCrop && (
              <canvas
                ref={previewCanvasRef}
                style={{
                  border: '1px solid black',
                  objectFit: 'contain',
                  width: maxWidth * scaleFactor,
                  height: maxHeight * scaleFactor,
                }}
              />
            )}
          </div>
        </Grid>
        <Grid item xs={1} />
      </Grid>

      <div></div>
    </div>
  );
};

export default CustomMultiFileCropper;
